declare global {
  /** Functions registered with `registerConsoleFunction`, e.g. `dev.resetTour()` */
  var dev: Record<string, (...args: never[]) => unknown> | undefined;
}

/**
 * Makes `fn` callable from the browser console as `dev.<name>()`.
 * Registering the same name again replaces it.
 */
export function registerConsoleFunction(
  name: string,
  fn: (...args: never[]) => unknown
) {
  globalThis.dev ??= {};
  globalThis.dev[name] = fn;
}
